/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePaymentMethodSetupSessionResponseData
 */
export interface CreatePaymentMethodSetupSessionResponseData {
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentMethodSetupSessionResponseData
     */
    redirectUrl: string;
}

/**
 * Check if a given object implements the CreatePaymentMethodSetupSessionResponseData interface.
 */
export function instanceOfCreatePaymentMethodSetupSessionResponseData(value: object): value is CreatePaymentMethodSetupSessionResponseData {
    if (!('redirectUrl' in value) || value['redirectUrl'] === undefined) return false;
    return true;
}

export function CreatePaymentMethodSetupSessionResponseDataFromJSON(json: any): CreatePaymentMethodSetupSessionResponseData {
    return CreatePaymentMethodSetupSessionResponseDataFromJSONTyped(json, false);
}

export function CreatePaymentMethodSetupSessionResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentMethodSetupSessionResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectUrl': json['redirectUrl'],
    };
}

  export function CreatePaymentMethodSetupSessionResponseDataToJSON(json: any): CreatePaymentMethodSetupSessionResponseData {
      return CreatePaymentMethodSetupSessionResponseDataToJSONTyped(json, false);
  }

  export function CreatePaymentMethodSetupSessionResponseDataToJSONTyped(value?: CreatePaymentMethodSetupSessionResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirectUrl': value['redirectUrl'],
    };
}

